<template>
	<div>
		<j-card v-for="(item, i) in list" :key="i" class="flex xs-middle mb2 bg5 p4">
			<div class="xs-6 fs3">
				<router-link
					:to="{ name: 'BindersUpdate', params: { id: item.binderId } }"
				>{{ item.binderNumber ? item.binderNumber : "---" }}</router-link>
			</div>
			<div class="flex xs-right xs-6">
				<crm-icon
					class="cu2"
					name="delete"
					color="cError"
					@click.native="removeContract(item.id)"
				/>
			</div>
		</j-card>

		<!-- No data -->
		<j-card
			v-if="!isLoading && list && !list.length"
			class="bg5 p4 ta2 fs3"
		>{{ $t("errors.no_data") }}</j-card>

		<!-- Add button -->
		<div class="xs-12 flex xs-right mt2">
			<j-button
				size="xsmall"
				@click="$modal.show('addAssociatedList')"
			>{{ $t("add") }}</j-button>
		</div>

		<!-- Add -->
		<core-modal name="addAssociatedList" :headline="$t('add')">
			<associated-contract-add
				style="min-height: 300px;"
				@contract:added="fetchList(), $modal.hide('addAssociatedList')"
			/>
		</core-modal>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import JButton from "@/components/JButton"
import CoreModal from "@/modules/core/components/CoreModal"
import AssociatedContractAdd from "./AssociatedContractAdd.vue"
import CrmIcon from "@/components/CrmIcon"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { JCard, JButton, CoreModal, AssociatedContractAdd, CrmIcon },

	data() {
		return {
			isLoading: false,
			list: []
		}
	},

	methods: {
		async fetchList() {
			const query = gql`
				query associatedContracts(
					$caseWhere: caseWhere
					$proposalWhere: proposalWhere
					$offerWhere: offerWhere
				) {
					cases(where: $caseWhere) {
						list {
							id
							proposals(where: $proposalWhere) {
								id
								basket(where: $offerWhere) {
									id
									associatedContracts {
										id
										contract {
											id
											name
											facts {
												type
												value {
													stringValue
												}
											}
										}
									}
								}
							}
						}
					}
				}
			`

			this.isLoading = true
			const res = await api({
				query,
				variables: {
					caseWhere: { id: this.$store.state.caseManagement.caseId },
					proposalWhere: { id: this.$store.state.caseManagement.proposalId },
					offerWhere: { id: this.$store.state.caseManagement.offerId }
				}
			})
			this.isLoading = false

			this.list =
				res?.data?.cases?.list?.[0]?.proposals?.[0]?.basket?.[0]?.associatedContracts?.map(
					item => ({
						id: item.id,
						binderId: item?.contract?.id,

						// HACK: we have this binderNumber defined as fact even though it's iportant to be displayed
						// We agreed on this with Bambi that we have it as fact
						binderNumber: item?.contract?.facts?.find(
							fact => fact.type === "binderNumber"
						)?.value?.stringValue
					})
				) || []
		},

		async removeContract(associatedContractId) {
			const query = gql`
				mutation removeAssociatedContractFromProposalOffer(
					$caseId: String!
					$proposalId: String!
					$offerId: String!
					$associatedContractId: String!
				) {
					removeAssociatedContractFromProposalOffer(
						caseId: $caseId
						proposalId: $proposalId
						offerId: $offerId
						associatedContractId: $associatedContractId
					) {
						status
						errors
					}
				}
			`

			const currentList = JSON.parse(JSON.stringify(this.list)) // Save for optimistic UI
			this.list = this.list.filter(item => item.id !== associatedContractId) // Remove from cache

			// Call
			const res = await api({
				query,
				variables: {
					caseId: this.$store.state.caseManagement.caseId,
					proposalId: this.$store.state.caseManagement.proposalId,
					offerId: this.$store.state.caseManagement.offerId,
					associatedContractId
				}
			})

			// Check errors
			if (
				res?.data?.removeAssociatedContractFromProposalOffer?.status !==
				"success"
			) {
				this.$store.dispatch(
					"showError",
					res?.data?.removeAssociatedContractFromProposalOffer?.errors?.[0] ||
						this.$t("errors.general")
				)
				// If error, revert optimistic UI
				this.list = currentList
				return
			}
		}
	},

	created() {
		this.fetchList()
	},

	watch: {
		"$store.state.caseManagement.offerId": {
			handler() {
				this.fetchList()
			}
		}
	}
}
</script>